setTimeout(() => {
    const ele = document.querySelector('cart-drawer');
    if(ele){
        const observer = new MutationObserver((MutationList) => {
            console.log(MutationList)
            for(let item of MutationList){
                if(item.target.localName === 'cart-drawer'){
                    const btn = document.querySelector('#CartDrawer-Checkout');
                    if(btn){
                        btn.removeAttribute('bss-b2b-cart-trigger-added');
                        BSS_B2B.observer.cartSubject.listenCartCheckout();
                         BSS_B2B.nt.initFunction()
                    }
                }
            }
        })
        observer.observe(ele, {childList: true, subtree: true})
    }
}, 300);


document.addEventListener("DOMContentLoaded", function () {
    let quickAddDrawer = document.querySelector('.drawer__footer')
                                    if (quickAddDrawer) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                                if (m.addedNodes.length) {
                                                    console.log('test')
                                                    BSS_B2B.nt.initFunction()
                                                }
                                            });
                                        });
                                        observer.observe(quickAddDrawer, {childList: true});
                                    }
                                    let a = document.querySelectorAll('.product-form__submit')
                                    if (a.length) {
                                        a.forEach(element => {
                                            element.addEventListener('click', ()=>{
                                          setTimeout(() => {
                                             BSS_B2B.nt.initFunction()
                                          }, 1500);
                                        })
                                        });
                                        
                                    }
});